import type { FaireProductEntity } from "../../entity_types/product";

export const p_rvrvkn2wxy: FaireProductEntity = {
  token: "p_rvrvkn2wxy",
  type: "product",
  name: "Get Well Flowers Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cfdea20d6c9daf598cae3dcaf0fb2d34246c6babad654e1fb0d708eb2e5f6de9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/709b153372ce250a01f9c524a6293c465301a05839fb590adf7f4b6dd8813e60.png",
    "https://cdn.faire.com/fastly/74ab1cd9106044f417b52f0e044809290a67c60ba1caf2733f3d7dce8df65fb0.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:11.566Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
